// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearcherList-cls1_-d4","cls2":"ResearcherList-cls2_HDB ResearcherList-cls1_-d4"};